// extracted by mini-css-extract-plugin
export var chip = "_bw-0";
export var filterDropdown = "_bw-5";
export var filterItem = "_bw-6";
export var icon = "_bw-1";
export var removeButton = "_bw-3";
export var removeIcon = "_bw-4";
export var separator = "_bw-2";